import { useLocation, useNavigate, useParams } from 'react-router-dom';
// mantine
import { Container, Tabs } from '@mantine/core';
// components
import { DollarSign, Users } from 'lucide-react';
import PageContainer from '@/components/Layout/components/PageContainer';
import Header from '@/components/Header';
import Billing from '@/pages/Profile/components/Billing';
import Members from '@/pages/Profile/components/Members';
// icons
// utils
import { useProfileQuery } from '@/services/customer/profile/profile.queries.ts';
import { PATHS } from '@/constants';

const Profile = () => {
    const navigate = useNavigate();
    const { tab } = useParams();
    const location = useLocation();
    const isCreatePartnerPage = location.pathname.includes(PATHS.createPartner);

    const { data: profile } = useProfileQuery(!isCreatePartnerPage);

    return (
        <PageContainer>
            <Header title="Profile" />
            <Container fluid maw={1400}>
                <div>
                    <Tabs
                        defaultValue="billing"
                        keepMounted={false}
                        value={tab}
                        onChange={async (value) =>
                            navigate(`${PATHS.profile.root}/${value}`)
                        }
                    >
                        <Tabs.List>
                            <Tabs.Tab
                                leftSection={<DollarSign />}
                                value="billing"
                            >
                                Billing
                            </Tabs.Tab>
                            <Tabs.Tab leftSection={<Users />} value="members">
                                Members
                            </Tabs.Tab>
                        </Tabs.List>
                        <Tabs.Panel className="pt-6" value="billing">
                            {profile ? (
                                <Billing profile={profile} />
                            ) : undefined}
                        </Tabs.Panel>
                        <Tabs.Panel className="pt-6" value="members">
                            <Members />
                        </Tabs.Panel>
                    </Tabs>
                </div>
            </Container>
        </PageContainer>
    );
};

export default Profile;
